import { useReducer, useEffect } from 'react'
import { useTheme, Tab, Tabs } from '@mui/material'
import {
    UniversalCookieCrumb,
    DataGridLayout,
    Grid,
} from '../../UniversalComponents'
import { useMinimizer } from '../../../context/MinimizeContext'
import NotificationManager from './SignalEventManager'
import UnitOfMeasureManager from './UnitOfMeasureManager'
import SignalManager from './SignalManager'
import SignalProfileManager from './SignalProfileManager'
import SignalFormulaManager from './SignalFormulaManager'
import { hashKey } from '@tanstack/react-query'

interface TabPanelProps {
    children?: React.ReactNode
    dir?: string
    index: number
    value: number
}

const TabPanel = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props

    return (
        <Grid
            container
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Grid container>
                    <Grid item xs={12} sx={{ padding: 2 }}>
                        {children}
                    </Grid>
                </Grid>
            )}
        </Grid>
    )
}

const Signals = () => {
    const reducer = (state, newState) => ({ ...state, ...newState })

    const defaultState = {
        currentTab: 0,
        tabName: '',
    }

    const [state, setState] = useReducer(reducer, defaultState)

    const { currentTab, tabName } = state

    const tabs = ['Signal Profile Manager', 'Signal Manager']

    const setCurrentTab = (event: React.SyntheticEvent, newValue: number) =>
        setState({ currentTab: newValue, tabName: tabs[newValue] })

    const theme = useTheme()
    const { restoredData } = useMinimizer()

    return (
        <DataGridLayout
            cookieCrumbs={<UniversalCookieCrumb customTitle={tabName} />}
            tabBar={
                <Tabs
                    value={currentTab}
                    onChange={setCurrentTab}
                    indicatorColor="secondary"
                    textColor="primary"
                    variant="scrollable"
                    aria-label="Osmosis"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                >
                    {tabs.map((label) => (
                        <Tab label={label} key={`${label}`} />
                    ))}
                </Tabs>
            }
            dataGrid={
                <>
                    <TabPanel
                        value={currentTab}
                        index={0}
                        dir={theme.direction}
                    >
                        <SignalProfileManager restoredData={restoredData} />
                    </TabPanel>
                    <TabPanel
                        value={currentTab}
                        index={1}
                        dir={theme.direction}
                    >
                        <SignalManager restoredData={restoredData} />
                    </TabPanel>
                </>
            }
        />
    )
}

export default Signals
